export interface AITagChipProps {
  label: string;
  onDelete: () => void;
  onSelect?: () => void;
  isSelected?: boolean;
  isEditable?: boolean;
}

const STYLE = {
  cursor: 'pointer',
};

export const AITagChip = ({
  label,
  onDelete,
  onSelect,
  isSelected,
  isEditable = true,
}: AITagChipProps) => {
  // Handle click based on editability and selection state
  const handleClick = () => {
    if (!isEditable) return;
    if (isSelected) {
      onDelete();
    } else if (onSelect) {
      onSelect();
    }
  };

  return (
    <div>
      <span
        className={isSelected ? 'tag tag--fill' : 'tag'}
        key="test"
        onClick={handleClick}
        style={isEditable ? STYLE : undefined}
      >
        {label}
        {isSelected && isEditable && <i className="icon-close2 remove" />}
      </span>
    </div>
  );
};
